import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useIsMobile } from '../hooks/useResponsive';
import toast from 'react-hot-toast';

const VD   = '#6D28D9';
const GOLD = '#C9A96E';
const serif = "'Cormorant Garamond', Georgia, serif";
const sans  = "'Montserrat', sans-serif";

export default function LoginPage() {
  const [mode, setMode]   = useState('login');
  const [form, setForm]   = useState({ name: '', email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const inp = {
    background: '#F8F7FF', border: '1px solid #E9E4FF', color: '#111',
    padding: '13px 16px', fontSize: 14, width: '100%',
    boxSizing: 'border-box', outline: 'none', marginBottom: 12, borderRadius: 4,
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (mode === 'login') {
        const user = await login(form.email, form.password);
        toast.success(`Bienvenue ${user.name} !`);
        navigate(user.role === 'admin' ? '/admin' : '/');
      } else {
        await register(form.name, form.email, form.password);
        toast.success('Compte créé !');
        navigate('/');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Erreur de connexion');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ background: 'linear-gradient(160deg, #3B0764, #6D28D9)', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem 1rem' }}>
      <div style={{ width: '100%', maxWidth: 420, background: '#fff', borderRadius: 12, padding: isMobile ? '2rem 1.5rem' : '3rem 2.5rem', boxShadow: '0 24px 64px rgba(0,0,0,0.3)' }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img src="/logo-banner.jpeg" alt="SS Parfumerie" style={{ width: 72, height: 72, borderRadius: '50%', objectFit: 'cover', objectPosition: 'center', marginBottom: 16 }} />
          <h1 style={{ fontFamily: serif, fontSize: 26, fontWeight: 400, color: VD, marginBottom: 4 }}>SS PARFUMERIE</h1>
          <p style={{ fontSize: 11, letterSpacing: 2, color: '#AAA', textTransform: 'uppercase' }}>
            {mode === 'login' ? 'Connexion' : 'Créer un compte'}
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          {mode === 'register' && (
            <input placeholder="Nom complet" value={form.name}
              onChange={e => setForm(p => ({ ...p, name: e.target.value }))} style={inp} required />
          )}
          <input type="email" placeholder="Email" value={form.email}
            onChange={e => setForm(p => ({ ...p, email: e.target.value }))} style={inp} required />
          <input type="password" placeholder="Mot de passe" value={form.password}
            onChange={e => setForm(p => ({ ...p, password: e.target.value }))} style={inp} required />

          <button type="submit" disabled={loading} style={{
            width: '100%', background: loading ? '#AAA' : VD, color: '#fff', border: 'none',
            padding: 16, fontSize: 11, letterSpacing: 3, textTransform: 'uppercase',
            cursor: loading ? 'not-allowed' : 'pointer', marginTop: 4, borderRadius: 6, fontFamily: sans, fontWeight: 700,
          }}>
            {loading ? '...' : mode === 'login' ? 'Se connecter' : 'Créer le compte'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: 24, fontSize: 13, color: '#777' }}>
          {mode === 'login' ? 'Pas encore de compte ? ' : 'Déjà un compte ? '}
          <button onClick={() => setMode(m => m === 'login' ? 'register' : 'login')}
            style={{ background: 'none', border: 'none', color: GOLD, cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
            {mode === 'login' ? 'Créer un compte' : 'Se connecter'}
          </button>
        </p>

        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <Link to="/" style={{ fontSize: 12, color: '#AAA', textDecoration: 'none' }}>← Retour à la boutique</Link>
        </div>
      </div>
    </div>
  );
}
